/* eslint-disable no-template-curly-in-string */
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import { useTranslation } from "react-i18next";

import './HelpSection.scss'

function HelpSection({ rtl, className }: any) {
    const dir = rtl ? 'right' : 'left';
    const { t } = useTranslation();

    return (
        <div className={`helpSection__container ${className}`}>
            <Typography className={`helpSection__needText sansFont fontFamily-${dir}`} rtl={rtl}>{t("Need_help")}</Typography>
            <Typography className={`helpSection__assistantText sansFont fontFamily-${dir}`} rtl={rtl}>
                {t("Request_an_Email")}
            </Typography>
            <Typography className={`helpSection__assistantEmail sansFont fontFamily-${dir}`} rtl={rtl} >
                <a className='help-mailTo' href="mailto:DigitalSalesB2B@Mobily.com.sa"> DigitalSalesB2B@Mobily.com.sa </a>
            </Typography>
            
        </div>
    )
}

export default HelpSection
